import React from "react";
import { t } from "ttag";

import { RequestAQuoteForm } from "../CRMForm/RequestAQuoteForm";
import { SlideoverModal } from "../SlideoverModal/SlideoverModal";

import slideoverStyles from "../SlideoverModal/SlideoverModal.module.scss";
import styles from "./QuoteSlider.module.scss";

type Props = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
};

export const QuoteSlider = ({ title, isOpen, onClose }: Props) => (
    <SlideoverModal
        isOpen={isOpen}
        onClose={onClose}
        theme="offWhite"
        title={t`Request a Quote`}
        titleClassName={styles.title}
        panelClassName={styles.panel}
    >
        <div className={slideoverStyles.body}>
            <RequestAQuoteForm
                title={title}
                layout="solo"
                custom_submit_url={null}
            />
        </div>
    </SlideoverModal>
);
